module.exports = __webpack_public_path__ + "img/bar-chart-selected.a76d2046.svg";